import { createFileRoute } from "@tanstack/react-router";
import FloridaBlueInsurance, { config } from "@/pages/FloridaBlueInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/florida-blue-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Florida Blue TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Florida Blue policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Florida Blue TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Florida Blue policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/florida-blue-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/florida-blue-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FloridaBlueInsurance />;
}
